export default {
  label: {
    title: 'Invitar usuarios',
    paginationTitle: 'Usuarios con acceso',
    description: 'Para agregar más de un correo, sepárelos con comas. Los correos agregados aparecerán en la lista abajo.',
    input: 'Agregar uno o más correos',
    users: 'Usuarios',
  },
  hint: {
    emptyEmail: 'Por favor ingrese un correo válido.',
    duplicateEmail: 'Correo incorrecto.',
  },
  button: {
    addUser: 'Agregar',
  },
  notification: {
    loadingData: 'Cargando datos...',
  },
};
